var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#c0b6f2;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#ffe380;}.cls-6{fill:#998dd9;}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:#eae6ff;}.cls-10,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill-rule:evenodd;}.cls-48,.cls-9{fill:#fff;}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:#b2d4ff;}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:#ffe2c9;}.cls-19{fill:#bbcbff;}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{opacity:0.5;}.cls-30{fill:url(#linear-gradient-21);}.cls-31,.cls-81{fill:#017fc9;}.cls-31{fill-opacity:0.5;}.cls-32{fill:#32ccff;}.cls-33{fill:url(#linear-gradient-22);}.cls-34{fill:#c4d4e0;}.cls-35{fill:#c3d4e0;}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:#839fb6;}.cls-41{fill:#f16780;}.cls-42{fill:url(#linear-gradient-27);}.cls-43{fill:url(#linear-gradient-28);}.cls-44{fill:url(#linear-gradient-29);}.cls-45{fill:url(#linear-gradient-30);}.cls-46{fill:#293147;}.cls-47{fill:url(#linear-gradient-31);}.cls-48,.cls-81{fill-opacity:0.3;}.cls-49{fill:#79e2f2;}.cls-51{fill:url(#linear-gradient-32);}.cls-52{fill:url(#linear-gradient-33);}.cls-53{fill:url(#linear-gradient-34);}.cls-54{fill:url(#linear-gradient-35);}.cls-55{fill:url(#linear-gradient-36);}.cls-56{fill:url(#linear-gradient-37);}.cls-57{fill:url(#linear-gradient-38);}.cls-58{fill:url(#linear-gradient-39);}.cls-59{fill:url(#linear-gradient-40);}.cls-60{fill:url(#linear-gradient-41);}.cls-61{fill:#292c36;}.cls-62{fill:#949da4;}.cls-63{fill:#c0c6cb;}.cls-64{fill:url(#linear-gradient-42);}.cls-65{fill:url(#linear-gradient-43);}.cls-66{fill:url(#linear-gradient-44);}.cls-67{fill:url(#linear-gradient-45);}.cls-68{fill:url(#linear-gradient-46);}.cls-69{fill:url(#linear-gradient-47);}.cls-70{fill:url(#linear-gradient-48);}.cls-71{fill:url(#linear-gradient-49);}.cls-72{fill:url(#linear-gradient-50);}.cls-73{fill:url(#linear-gradient-51);}.cls-74{fill:url(#linear-gradient-52);}.cls-75{fill:url(#linear-gradient-53);}.cls-76{fill:url(#linear-gradient-54);}.cls-77{fill:url(#linear-gradient-55);}.cls-78{fill:url(#linear-gradient-56);}.cls-79{fill:url(#linear-gradient-57);}.cls-80{fill:url(#linear-gradient-58);}.cls-82{fill:#212f4c;}.cls-83{fill:url(#linear-gradient-59);}.cls-84{fill:url(#linear-gradient-60);}.cls-85{fill:url(#linear-gradient-61);}.cls-86{fill:url(#linear-gradient-62);}.cls-87{fill:url(#linear-gradient-63);}.cls-88{fill:url(#linear-gradient-64);}.cls-89{fill:url(#linear-gradient-65);}.cls-90{fill:url(#linear-gradient-66);}.cls-91{fill:url(#linear-gradient-67);}.cls-92{fill:url(#linear-gradient-68);}.cls-93{fill:url(#linear-gradient-69);}.cls-94{fill:url(#linear-gradient-70);}.cls-95{fill:url(#linear-gradient-71);}.cls-96{fill:url(#linear-gradient-72);}.cls-97{fill:url(#linear-gradient-73);}.cls-98{fill:url(#linear-gradient-74);}.cls-99{fill:url(#linear-gradient-75);}.cls-100{fill:url(#linear-gradient-76);}.cls-101{fill:url(#linear-gradient-77);}.cls-102{fill:url(#linear-gradient-78);}.cls-103{fill:url(#linear-gradient-79);}.cls-104{fill:url(#linear-gradient-80);}.cls-105{fill:url(#linear-gradient-81);}.cls-106{fill:url(#linear-gradient-82);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 185.16,
    y1: -6976.2,
    x2: 185.16,
    y2: -7014.16,
    gradientTransform: "matrix(0.98, 0.21, 0.21, -0.98, 1468.4, -6843.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff0b2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 185.19,
    y1: -6981.82,
    x2: 185.19,
    y2: -7008.57,
    gradientTransform: "matrix(0.98, 0.21, 0.21, -0.98, 1468.4, -6843.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe380",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 185.21,
    y1: 34.28,
    x2: 185.21,
    y2: 45.73,
    gradientTransform: "translate(9.64 -37.23) rotate(12.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc7c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 185.21,
    y1: 25.67,
    x2: 185.21,
    y2: 45.72,
    gradientTransform: "translate(9.64 -37.23) rotate(12.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaf73",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ffc7c7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbfb",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 59.87,
    y1: 189.52,
    x2: 170.96,
    y2: 300.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3bcd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79a6cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 83.14,
    y1: 323.47,
    x2: 62.09,
    y2: 323.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6554c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 59.57,
    y1: 337.77,
    x2: 85.76,
    y2: 309.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6eef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2f6f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 57.4,
    y1: 158.15,
    x2: 155.41,
    y2: 158.15,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 57.4,
    y1: 181.81,
    x2: 112.76,
    y2: 181.81,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 57.4,
    y1: 169.99,
    x2: 166.27,
    y2: 169.99,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 57.4,
    y1: 300.26,
    x2: 164.85,
    y2: 300.26,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 274.78,
    y1: 258.79,
    x2: 274.78,
    y2: 183.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aec4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7896ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 240.3,
    y1: 249.51,
    x2: 289.96,
    y2: 344.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8594ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 216.73,
    y1: 158.15,
    x2: 319.48,
    y2: 158.15,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 216.73,
    y1: 169.99,
    x2: 320.89,
    y2: 169.99,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 216.73,
    y1: 373.3,
    x2: 310.92,
    y2: 373.3,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 216.73,
    y1: 409.76,
    x2: 283.74,
    y2: 409.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 216.71,
    y1: 385.88,
    x2: 314.7,
    y2: 385.88,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 216.71,
    y1: 397.74,
    x2: 325.56,
    y2: 397.74,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 238.4,
    y1: 314.84,
    x2: 311.16,
    y2: 314.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 376.14,
    y1: 167.21,
    x2: 490.71,
    y2: 167.21,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 214.53,
    y1: 134.82,
    x2: 186.43,
    y2: 106.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35425f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 306.4,
    y1: 201,
    x2: 192.96,
    y2: 79.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4469d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 396.35,
    y1: 221.39,
    x2: 213.21,
    y2: 126.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c85ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 192.88,
    y1: 183.06,
    x2: 271.92,
    y2: 183.06,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 155.47,
    y1: 79.97,
    x2: 289.7,
    y2: 79.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6e2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d3e0dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cadbd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#bad3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a4c7cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#88b7c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#65a4b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589db5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 144.05,
    y1: 96.16,
    x2: 144.05,
    y2: 51.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#589db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6e2dd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 171.14,
    y1: 112.57,
    x2: 171.14,
    y2: 94.48,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 194.19,
    y1: 109.01,
    x2: 181.16,
    y2: 113.29,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 164.86,
    y1: 103.08,
    x2: 152.03,
    y2: 108,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 185.03,
    y1: 137.23,
    x2: 156.6,
    y2: 108.79,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 404.64,
    y1: 288.22,
    x2: 424.59,
    y2: 337.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#856cbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 409.88,
    y1: 296.08,
    x2: 409.88,
    y2: 330.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 396.47,
    y1: 504.73,
    x2: 396.47,
    y2: 447.7,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 412.99,
    y1: 394.2,
    x2: 412.99,
    y2: 333.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35425f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51588d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 406.04,
    y1: 323.19,
    x2: 413.61,
    y2: 318.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#332858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d641ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 413.83,
    y1: 320.91,
    x2: 406.74,
    y2: 326.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a156be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d641ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 416.61,
    y1: 328.66,
    x2: 416.61,
    y2: 337.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d838ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 414.33,
    y1: 447.57,
    x2: 414.33,
    y2: 333.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#026aa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29cce5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 429.37,
    y1: 390.26,
    x2: 439.82,
    y2: 379.82,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 403.4,
    y1: 504.73,
    x2: 403.4,
    y2: 447.7,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 365.35,
    y1: 411.97,
    x2: 336.63,
    y2: 454.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a7c8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 328.38,
    y1: 416.53,
    x2: 335.53,
    y2: 431.64,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 315.52,
    y1: 405.81,
    x2: 337.63,
    y2: 464.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 330.93,
    y1: 446.27,
    x2: 330.78,
    y2: 440.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 317.84,
    y1: 471.98,
    x2: 348.67,
    y2: 471.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#009ef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#004988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 355.51,
    y1: 511.23,
    x2: 333.01,
    y2: 474.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d6072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94a5af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 387.69,
    y1: 476.61,
    x2: 354.79,
    y2: 534.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#94a5af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -7942.95,
    y1: 2721.42,
    x2: -7937.28,
    y2: 2721.42,
    gradientTransform: "matrix(0.38, -0.93, 0.93, 0.36, 767.65, -7908.08)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 325.56,
    y1: 454.86,
    x2: 316.15,
    y2: 460.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d56be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d641ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 315.23,
    y1: 456.59,
    x2: 314.19,
    y2: 458.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d56be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d641ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 332.89,
    y1: 490.22,
    x2: 315.56,
    y2: 484.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0c6cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 321.72,
    y1: 506.33,
    x2: 318.95,
    y2: 523.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d6072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#94a5af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 329.57,
    y1: 514.48,
    x2: 321.32,
    y2: 514.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ced4da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 330.69,
    y1: 513.49,
    x2: 342.46,
    y2: 518.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6c6cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 356.67,
    y1: 510,
    x2: 378.73,
    y2: 490.24,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 372.8,
    y1: 504.67,
    x2: 347.43,
    y2: 501.34,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 347.83,
    y1: 514.2,
    x2: 367.2,
    y2: 519.74,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -145.23,
    y1: 304.39,
    x2: -186.23,
    y2: 304.39,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#a5b4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -162.24,
    y1: 304.52,
    x2: -162.24,
    y2: 333.09,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -154.21,
    y1: 322.28,
    x2: -152.26,
    y2: 314.77,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -173.63,
    y1: 311.64,
    x2: -159.76,
    y2: 337.38,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -101.49,
    y1: 330.07,
    x2: -115.61,
    y2: 329.95,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -123.26,
    y1: 322.37,
    x2: -93.32,
    y2: 322.37,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#586582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -113.44,
    y1: 337.84,
    x2: -211.09,
    y2: 387.17,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -116.32,
    y1: 336.47,
    x2: -110.42,
    y2: 345.12,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -94.75,
    y1: 327.6,
    x2: -89.63,
    y2: 327.6,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd71e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -174.6,
    y1: 350.6,
    x2: -181.95,
    y2: 328,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#526388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636a99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -194.65,
    y1: 339.65,
    x2: -235.34,
    y2: 398.71,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -176.82,
    y1: 312.66,
    x2: -176.82,
    y2: 333.73,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -168.88,
    y1: 405.08,
    x2: -206.29,
    y2: 405.08,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -178.93,
    y1: 443.96,
    x2: -102.65,
    y2: 570.48,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -8470.9,
    y1: 2007.64,
    x2: -8465.21,
    y2: 2007.64,
    gradientTransform: "matrix(-0.31, -0.95, -0.95, 0.31, -516.45, -8270.63)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -234.05,
    y1: 414.44,
    x2: -231.4,
    y2: 403.57,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -233.18,
    y1: 412.99,
    x2: -244.25,
    y2: 412.77,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -217.24,
    y1: 467.13,
    x2: -192.28,
    y2: 433.82,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -142.13,
    y1: 513.82,
    x2: -168.18,
    y2: 513.82,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ddaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee9bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -168.21,
    y1: 519.05,
    x2: -142.24,
    y2: 519.05,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -161.79,
    y1: 514.38,
    x2: -161.79,
    y2: 507.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -209.1,
    y1: 514.27,
    x2: -235,
    y2: 514.27,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -235.02,
    y1: 519.05,
    x2: -209.06,
    y2: 519.05,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -228.98,
    y1: 514.38,
    x2: -228.98,
    y2: 508.54,
    gradientTransform: "matrix(-1, 0, 0, 1, -17.4, 0)",
    xlinkHref: "#linear-gradient-33"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cobra id pages_trello_left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer19_0_FILL",
    "data-name": "Layer19 0 FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.42,16.85a19,19,0,0,0-22.54,14.58,18.3,18.3,0,0,0,2.63,14.28A19,19,0,0,0,202,39.38a18.27,18.27,0,0,0-2.61-14.28A18.32,18.32,0,0,0,187.42,16.85Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 180.46,
    cy: 49.52,
    r: 3.81
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer18_0_FILL",
    "data-name": "Layer18 0 FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.73,46.66a12.89,12.89,0,0,0,5.81-8.43,12.85,12.85,0,0,0-1.85-10.07,13.37,13.37,0,0,0-24.3,4.46A13.36,13.36,0,0,0,180.66,48.5,12.89,12.89,0,0,0,190.73,46.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer17_0_FILL",
    "data-name": "Layer17 0 FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.36,35.68a1.85,1.85,0,0,0-1.44.27,1.83,1.83,0,0,0-.83,1.21l-.19.93-1.87-.4.19-.93a1.92,1.92,0,0,0-.26-1.45,1.86,1.86,0,0,0-1.2-.83,1.84,1.84,0,0,0-1.44.27,1.86,1.86,0,0,0-.83,1.21,1.81,1.81,0,0,0,.26,1.43,1.9,1.9,0,0,0,1.2.83l.93.19-.72,3.43-.88,4,.17,0h.07l.7.15.83-3.88.77-3.6,1.87.41-.76,3.58-.84,3.89.93.2.87-4.06.74-3.42.93.21a1.86,1.86,0,0,0,1.43-.27,1.91,1.91,0,0,0,.84-1.2,1.85,1.85,0,0,0-.28-1.43,1.8,1.8,0,0,0-1.19-.84m-.93,1.07a1,1,0,0,1,1.46,1,.89.89,0,0,1-.43.59.88.88,0,0,1-.71.13l-.93-.2.21-.93a.92.92,0,0,1,.4-.6m-4.88-1.33a.91.91,0,0,1,.6.43.83.83,0,0,1,.13.7l-.19.93-.93-.2a.91.91,0,0,1-.6-.42.89.89,0,0,1-.14-.71,1,1,0,0,1,.41-.59A.93.93,0,0,1,180.55,35.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "181.82 38.62 181.05 42.21 180.22 46.09 181.86 46.44 182.09 46.49 182.93 42.6 183.69 39.02 181.82 38.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.46,38.35a.89.89,0,0,0,.43-.59,1,1,0,0,0-1.46-1,.92.92,0,0,0-.4.6l-.21.93.93.2A.88.88,0,0,0,186.46,38.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.55,35.42a.93.93,0,0,0-.72.14,1,1,0,0,0-.41.59.89.89,0,0,0,.14.71.91.91,0,0,0,.6.42l.93.2.19-.93a.83.83,0,0,0-.13-.7A.91.91,0,0,0,180.55,35.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.45,36.65a9.12,9.12,0,0,0-.23-3.12A9.31,9.31,0,0,0,191,30.69a9,9,0,0,0-2.07-2.29,9.15,9.15,0,0,0-2.78-1.5l-.4-.13-.39-.08-.4-.07-.39-.06a9,9,0,0,0-3.15.23,9.22,9.22,0,0,0-5.11,3.3,9.32,9.32,0,0,0-1.5,2.77,9.49,9.49,0,0,0-.38,4.32A9.28,9.28,0,0,0,175.94,41,9.61,9.61,0,0,1,177,43.16a6.3,6.3,0,0,1,.38,2.32l1.87.4.88-4,.72-3.43-.93-.19a1.9,1.9,0,0,1-1.2-.83,1.81,1.81,0,0,1-.26-1.43,1.86,1.86,0,0,1,.83-1.21,1.84,1.84,0,0,1,1.44-.27,1.86,1.86,0,0,1,1.2.83,1.92,1.92,0,0,1,.26,1.45l-.19.93,1.87.4.19-.93a1.83,1.83,0,0,1,.83-1.21,1.85,1.85,0,0,1,1.44-.27,1.8,1.8,0,0,1,1.19.84,1.85,1.85,0,0,1,.28,1.43,1.91,1.91,0,0,1-.84,1.2,1.86,1.86,0,0,1-1.43.27l-.93-.21-.74,3.42L183,46.69l.08,0,1.79.38a6.47,6.47,0,0,1,1.31-2,9.59,9.59,0,0,1,1.87-1.51,9.15,9.15,0,0,0,3-2.88,9.27,9.27,0,0,0,1.11-2.44A10.94,10.94,0,0,0,192.45,36.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer9_0_FILL",
    "data-name": "Layer9 0 FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.25,48a.42.42,0,0,0,.06.35.48.48,0,0,0,.31.22l1.87.39.19-.93-1.86-.4a.45.45,0,0,0-.35,0,.44.44,0,0,0-.22.32m-1.45-.67a.57.57,0,0,0-.32-.21l-3.26-.69-.2.94,3.26.69a.42.42,0,0,0,.37-.05.54.54,0,0,0,.2-.31A.5.5,0,0,0,180.8,47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.43,45.5l-.21.93,3.26.69a.57.57,0,0,1,.32.21.5.5,0,0,1,0,.37.54.54,0,0,1-.2.31.42.42,0,0,1-.37.05L177,47.37l-.3,1.39.94.2,5.59,1.19.94.22.3-1.41-1.87-.39a.48.48,0,0,1-.31-.22.42.42,0,0,1-.06-.35.44.44,0,0,1,.22-.32.45.45,0,0,1,.35,0l1.86.4.21-.94-1.79-.38-1.24-.27-1.64-.35-.7-.15h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.36,35.68a1.85,1.85,0,0,0-1.44.27,1.83,1.83,0,0,0-.83,1.21l-.19.93-1.87-.4.19-.93a1.92,1.92,0,0,0-.26-1.45,1.86,1.86,0,0,0-1.2-.83,1.84,1.84,0,0,0-1.44.27,1.86,1.86,0,0,0-.83,1.21,1.81,1.81,0,0,0,.26,1.43,1.9,1.9,0,0,0,1.2.83l.93.19-.72,3.43-.88,4,.17,0h.07l.7.15.83-3.88.77-3.6,1.87.41-.76,3.58-.84,3.89.93.2.87-4.06.74-3.42.93.21a1.86,1.86,0,0,0,1.43-.27,1.91,1.91,0,0,0,.84-1.2,1.85,1.85,0,0,0-.28-1.43,1.8,1.8,0,0,0-1.19-.84m-.93,1.07a1,1,0,0,1,1.46,1,.89.89,0,0,1-.43.59.88.88,0,0,1-.71.13l-.93-.2.21-.93a.92.92,0,0,1,.4-.6m-4.88-1.33a.91.91,0,0,1,.6.43.83.83,0,0,1,.13.7l-.19.93-.93-.2a.91.91,0,0,1-.6-.42.89.89,0,0,1-.14-.71,1,1,0,0,1,.41-.59A.93.93,0,0,1,180.55,35.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M183.69,39l-.76,3.58-.84,3.89-.23-.05-1.64-.35.83-3.88.77-3.6Zm-3.14-3.6a.93.93,0,0,0-.72.14,1,1,0,0,0-.41.59.89.89,0,0,0,.14.71.91.91,0,0,0,.6.42l.93.2.19-.93a.83.83,0,0,0-.13-.7A.91.91,0,0,0,180.55,35.42Zm5.91,2.93a.89.89,0,0,0,.43-.59,1,1,0,0,0-1.46-1,.92.92,0,0,0-.4.6l-.21.93.93.2A.88.88,0,0,0,186.46,38.35Zm6-1.7a9.12,9.12,0,0,0-.23-3.12A9.31,9.31,0,0,0,191,30.69a9,9,0,0,0-2.07-2.29,9.15,9.15,0,0,0-2.78-1.5l-.4-.13-.39-.08-.4-.07-.39-.06a9,9,0,0,0-3.15.23,9.22,9.22,0,0,0-5.11,3.3,9.32,9.32,0,0,0-1.5,2.77,9.49,9.49,0,0,0-.38,4.32A9.28,9.28,0,0,0,175.94,41,9.61,9.61,0,0,1,177,43.16a6.3,6.3,0,0,1,.38,2.32l1.87.4.88-4,.72-3.43-.93-.19a1.9,1.9,0,0,1-1.2-.83,1.81,1.81,0,0,1-.26-1.43,1.86,1.86,0,0,1,.83-1.21,1.84,1.84,0,0,1,1.44-.27,1.86,1.86,0,0,1,1.2.83,1.92,1.92,0,0,1,.26,1.45l-.19.93,1.87.4.19-.93a1.83,1.83,0,0,1,.83-1.21,1.85,1.85,0,0,1,1.44-.27,1.8,1.8,0,0,1,1.19.84,1.85,1.85,0,0,1,.28,1.43,1.91,1.91,0,0,1-.84,1.2,1.86,1.86,0,0,1-1.43.27l-.93-.21-.74,3.42L183,46.69l.08,0,1.79.38a6.47,6.47,0,0,1,1.31-2,9.59,9.59,0,0,1,1.87-1.51,9.15,9.15,0,0,0,3-2.88,9.27,9.27,0,0,0,1.11-2.44A10.94,10.94,0,0,0,192.45,36.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M181.53,128.19q7.49.23,7.48,7.87V346q0,7.69-7.48,7.93H50.11q-7.89,0-7.88-7.93V136.06q0-7.87,7.88-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180.9,160.39v25.53q0,5.54-5.59,5.54H55.54c-3.74,0-5.6-1.85-5.6-5.54v-32.2c0-3.72,1.86-5.57,5.6-5.57H175.31c3.73,0,5.59,1.85,5.59,5.57Zm-131,130.28h131V340.8q0,5.52-5.59,5.52H55.54c-3.74,0-5.6-1.84-5.6-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M180.9,290.67h-131V202.19c0-3.67,1.86-5.51,5.6-5.51H175.31q5.59,0,5.59,5.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options",
    className: "cls-11",
    cx: 177.14,
    cy: 138.2,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-2",
    "data-name": "Options",
    className: "cls-11",
    cx: 168.64,
    cy: 138.24,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-3",
    "data-name": "Options",
    className: "cls-11",
    cx: 160.15,
    cy: 138.28,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M97.52,141.79h0l-44.41-.21a3.06,3.06,0,0,1,0-6.12h0l44.41.21a3.06,3.06,0,0,1,0,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M62.83,325.89a2.31,2.31,0,0,1-.74-1.67,2.46,2.46,0,0,1,2.37-2.4,2.34,2.34,0,0,1,1.7.7l3.28,3.28,9.67-9.67a2.16,2.16,0,0,1,1.66-.68,2.36,2.36,0,0,1,2.37,2.4,2.27,2.27,0,0,1-.7,1.66L71.1,330.79a2.23,2.23,0,0,1-1.66.7,2.16,2.16,0,0,1-1.67-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M62.83,325.89l4.94,4.9a2.16,2.16,0,0,0,1.67.7,2.23,2.23,0,0,0,1.66-.7l11.34-11.28a2.27,2.27,0,0,0,.7-1.66,2.36,2.36,0,0,0-2.37-2.4,2.16,2.16,0,0,0-1.66.68l-9.67,9.67-3.28-3.28a2.34,2.34,0,0,0-1.7-.7,2.46,2.46,0,0,0-2.37,2.4A2.31,2.31,0,0,0,62.83,325.89Zm.75,12.89q-6.27,0-6.27-6.34v-18q0-6.32,6.27-6.32H81.65q6.36,0,6.36,6.32v18q0,6.35-6.36,6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M153,155.78a2.25,2.25,0,0,1,1.7.74,2.15,2.15,0,0,1,.69,1.63,2.34,2.34,0,0,1-2.39,2.36H59.76a2.2,2.2,0,0,1-1.66-.68,2.29,2.29,0,0,1-.7-1.68,2.12,2.12,0,0,1,.7-1.63,2.15,2.15,0,0,1,1.66-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M110.4,179.44a2.32,2.32,0,0,1,1.73.73,2.25,2.25,0,0,1,.63,1.63,2.52,2.52,0,0,1-.63,1.72,2.46,2.46,0,0,1-1.73.66H59.76a2.36,2.36,0,0,1-1.52-.5.76.76,0,0,1-.14-.16,2.36,2.36,0,0,1-.7-1.72,2.12,2.12,0,0,1,.7-1.63,2.14,2.14,0,0,1,1.66-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M163.94,167.63a2.34,2.34,0,0,1,2.33,2.36,2.34,2.34,0,0,1-.67,1.68,2.27,2.27,0,0,1-1.66.69H59.76a2.21,2.21,0,0,1-1.66-.69,2.29,2.29,0,0,1-.7-1.68,2.21,2.21,0,0,1,.7-1.66,2.18,2.18,0,0,1,1.66-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M162.5,297.89a2.37,2.37,0,0,1,1.7.7,2.32,2.32,0,0,1,.65,1.67,2.31,2.31,0,0,1-2.35,2.36H59.76a2.18,2.18,0,0,1-1.66-.7,2.23,2.23,0,0,1-.7-1.66,2.39,2.39,0,0,1,2.36-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M340.84,128.19q7.52.23,7.52,7.87v282.7q0,7.73-7.52,7.89H209.49q-7.87,0-7.88-7.89V136.06q0-7.87,7.88-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.3,153.72v19.5q0,5.57-5.61,5.57H214.89q-5.62,0-5.63-5.57v-19.5c0-3.72,1.88-5.57,5.63-5.57h119.8C338.43,148.15,340.3,150,340.3,153.72ZM253.06,363.77l68-.06,19.26.06v49.88c0,3.66-1.87,5.5-5.61,5.5H214.89c-3.75,0-5.63-1.84-5.63-5.5V363.77l19.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M161.22,219.43l-.24-.07a3.57,3.57,0,0,1-2.37-1.57,1.86,1.86,0,0,1-.28-.48,3.65,3.65,0,0,1-.31-2.4,3.58,3.58,0,0,1,1.63-2.34,3.64,3.64,0,0,1,5.22,1.07,3.39,3.39,0,0,1,.56,2.76,3.76,3.76,0,0,1-1.6,2.46A3.4,3.4,0,0,1,161.22,219.43ZM99.29,240a3.71,3.71,0,0,1-.07-1.91,3.78,3.78,0,0,1,1.65-2.38,3.66,3.66,0,0,1,2.84-.53,3.55,3.55,0,0,1,2.36,1.58,4,4,0,0,1,.67,2.49c0,.14-.06.25-.09.35a3.53,3.53,0,0,1-1.65,2.43.78.78,0,0,1-.3.18,3.55,3.55,0,0,1-2.5.37,1.8,1.8,0,0,0-.35-.07,3.63,3.63,0,0,1-2-1.53A4.81,4.81,0,0,1,99.29,240Zm25.42,12.9a3.48,3.48,0,0,1,2.52-.39,2.34,2.34,0,0,1,.32.07,3.81,3.81,0,0,1,2.14,1.52,5.25,5.25,0,0,1,.42,1,3.51,3.51,0,0,1,.1,1.85,3.93,3.93,0,0,1-1.61,2.44,3.79,3.79,0,0,1-2.87.52,3.6,3.6,0,0,1-2.4-1.61,3.37,3.37,0,0,1-.58-2.38,2.42,2.42,0,0,1,.07-.47,3.77,3.77,0,0,1,1.59-2.42A1.7,1.7,0,0,0,124.71,252.92ZM70.35,269.26a3.32,3.32,0,0,1,2,1.47,4.39,4.39,0,0,1,.52,1,3.51,3.51,0,0,1,.07,1.8,3.87,3.87,0,0,1-4.48,3,3.59,3.59,0,0,1-2.38-1.63,3.77,3.77,0,0,1,1-5.24,3.58,3.58,0,0,1,2.84-.54A1.11,1.11,0,0,1,70.35,269.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M161.22,219.43l-31.11,35.68a5.25,5.25,0,0,0-.42-1,3.81,3.81,0,0,0-2.14-1.52l30.78-35.29a1.86,1.86,0,0,0,.28.48,3.57,3.57,0,0,0,2.37,1.57Zm-54.48,19.84,18,13.65a1.7,1.7,0,0,1-.3.12,3.77,3.77,0,0,0-1.59,2.42,2.42,2.42,0,0,0-.07.47l-18-13.7a.78.78,0,0,0,.3-.18,3.53,3.53,0,0,0,1.65-2.43C106.68,239.52,106.71,239.41,106.74,239.27Zm-7.45.75a4.81,4.81,0,0,0,.51,1,3.63,3.63,0,0,0,2,1.53L72.9,271.77a4.39,4.39,0,0,0-.52-1,3.32,3.32,0,0,0-2-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M340.3,189.21v64.06q0,5.39-5.31,5.52H214.89q-5.62,0-5.63-5.52V189.21q0-5.52,5.63-5.52H335Q340.3,183.86,340.3,189.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M228.33,363.71l-19.07.06V269.3a6.48,6.48,0,0,1,.57-2.88q1.15-2.55,4.83-2.64h120q5.61,0,5.61,5.52v94.47L321,363.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-4",
    "data-name": "Options",
    className: "cls-11",
    cx: 338.61,
    cy: 137.03,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-5",
    "data-name": "Options",
    className: "cls-11",
    cx: 330.11,
    cy: 137.07,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-6",
    "data-name": "Options",
    className: "cls-11",
    cx: 321.62,
    cy: 137.11,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M259,140.63h0l-44.41-.21a3.06,3.06,0,0,1,0-6.12h0l44.41.21a3.06,3.06,0,0,1,0,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M219.09,160.51a2.15,2.15,0,0,1-1.63-.68,2.24,2.24,0,0,1-.73-1.68,2.08,2.08,0,0,1,.73-1.63,2.1,2.1,0,0,1,1.63-.74h98a2.32,2.32,0,0,1,1.72.74,2.19,2.19,0,0,1,.66,1.63,2.29,2.29,0,0,1-2.38,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M217.46,168.33a2.13,2.13,0,0,1,1.63-.7h99.43a2.45,2.45,0,0,1,1.73.7,2.32,2.32,0,0,1,.64,1.66,2.4,2.4,0,0,1-.64,1.68,2.49,2.49,0,0,1-1.73.69H219.09a2.16,2.16,0,0,1-1.63-.69,2.24,2.24,0,0,1-.73-1.68A2.17,2.17,0,0,1,217.46,168.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M308.52,370.93a2.37,2.37,0,0,1,2.4,2.37,2.25,2.25,0,0,1-.7,1.66,2.29,2.29,0,0,1-1.7.7H219.09a2.13,2.13,0,0,1-1.63-.7,2.17,2.17,0,0,1-.73-1.66,2.21,2.21,0,0,1,.73-1.68,2.16,2.16,0,0,1,1.63-.69h89.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M281.38,407.39a2.27,2.27,0,0,1,1.66.68,2.3,2.3,0,0,1,.7,1.69,2.39,2.39,0,0,1-2.36,2.36H219.09a2.13,2.13,0,0,1-1.63-.7,2.17,2.17,0,0,1-.73-1.66,2.25,2.25,0,0,1,.73-1.69,2.19,2.19,0,0,1,1.63-.68h62.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M312.32,383.51a2.23,2.23,0,0,1,1.7.74,2.16,2.16,0,0,1,.68,1.63,2.32,2.32,0,0,1-2.38,2.36H219.08a2.29,2.29,0,0,1-1.69-.68,2.32,2.32,0,0,1-.68-1.68,2.16,2.16,0,0,1,.68-1.63,2.2,2.2,0,0,1,1.69-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M324.9,396.06a2.31,2.31,0,0,1,.66,1.68,2.38,2.38,0,0,1-.66,1.66,2.27,2.27,0,0,1-1.67.7H219.08a2.23,2.23,0,0,1-1.69-.7,2.35,2.35,0,0,1-.68-1.66,2.28,2.28,0,0,1,.68-1.68,2.26,2.26,0,0,1,1.69-.69H323.23A2.3,2.3,0,0,1,324.9,396.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M276.68,333.81a2.75,2.75,0,0,1,.9-2.07,2.84,2.84,0,0,1,2.09-.89h27.85a2.9,2.9,0,0,1,2.11.89,2.8,2.8,0,0,1,.87,2.07v19.58a2.94,2.94,0,0,1-3,3H279.67a3,3,0,0,1-3-3Zm-37.67,0a2.78,2.78,0,0,1,.89-2.07,2.84,2.84,0,0,1,2.1-.89h27.85a2.9,2.9,0,0,1,2.11.89,2.8,2.8,0,0,1,.87,2.07v19.58a2.94,2.94,0,0,1-3,3H242a3,3,0,0,1-3-3Zm2.35-54.52a2.85,2.85,0,0,1-2.07-.85,2.92,2.92,0,0,1-.89-2.12,3,3,0,0,1,3-3H308.2a2.92,2.92,0,0,1,2.12.89,2.86,2.86,0,0,1,.84,2.09,2.89,2.89,0,0,1-3,3ZM239,288.22a3,3,0,0,1,3-3h65.52a2.9,2.9,0,0,1,2.11.89,2.86,2.86,0,0,1,.87,2.1V321a2.94,2.94,0,0,1-.87,2.12,3,3,0,0,1-2.11.84H242a3,3,0,0,1-3-3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M500.26,128.19q7.51.23,7.51,7.87v54.37q0,7.65-7.51,7.88H368.86q-7.89,0-7.89-7.88V136.06q0-7.87,7.89-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M374.07,148.82H494.29a5.39,5.39,0,0,1,5.39,5.39V185q0,5.52-5.63,5.52H374.3q-5.62,0-5.62-5.52V154.21A5.39,5.39,0,0,1,374.07,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M460.7,170.74a2.27,2.27,0,0,1,1.71.74,2.15,2.15,0,0,1,.67,1.65,2.28,2.28,0,0,1-2.38,2.36H378.51a2.33,2.33,0,0,1-1.67-.66,2.39,2.39,0,0,1-.7-1.7,2.14,2.14,0,0,1,.7-1.65,2.22,2.22,0,0,1,1.67-.74H460.7Zm29.36-11.12a2.41,2.41,0,0,1,.65,1.68,2.29,2.29,0,0,1-2.37,2.37H378.51a2.28,2.28,0,0,1-1.67-.69,2.36,2.36,0,0,1-.7-1.68,2.33,2.33,0,0,1,.7-1.68,2.28,2.28,0,0,1,1.67-.69H488.34A2.43,2.43,0,0,1,490.06,159.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-7",
    "data-name": "Options",
    className: "cls-11",
    cx: 495.77,
    cy: 137.82,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-8",
    "data-name": "Options",
    className: "cls-11",
    cx: 487.27,
    cy: 137.86,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Options-9",
    "data-name": "Options",
    className: "cls-11",
    cx: 478.78,
    cy: 137.89,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M416.15,141.41h0l-44.4-.21a3.06,3.06,0,0,1,0-6.12h0l44.41.21a3.06,3.06,0,0,1,0,6.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M204.39,139l1.16,0h.68L326,143.14q5.58.18,5.39,5.7l-2.19,64q-.23,5.52-5.85,5.34l-3.7-.12H319L201.63,214V141.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M217.57,131.82a3.65,3.65,0,0,0,1.14-2.3,7.27,7.27,0,0,1,4.13,2.3.91.91,0,0,1,.25.85,1.16,1.16,0,0,1-.3.81,1.43,1.43,0,0,1-.86.35,1,1,0,0,1-.82-.37A4.84,4.84,0,0,0,217.57,131.82Zm-1.16-6a.52.52,0,0,1,.21-.07,7,7,0,0,1,7.59,2,1.67,1.67,0,0,1,.3.87,1,1,0,0,1-.44.81.91.91,0,0,1-.81.26,1.29,1.29,0,0,1-.82-.33,4.69,4.69,0,0,0-4-1.61,2.91,2.91,0,0,0-.69-1A3.56,3.56,0,0,0,216.41,125.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M216.41,125.77a3.56,3.56,0,0,1,1.33.91,2.91,2.91,0,0,1,.69,1,3.42,3.42,0,0,1,.28,1.56.49.49,0,0,1,0,.24,3.65,3.65,0,0,1-1.14,2.3v.08a3.54,3.54,0,0,1-2.66.95q-22.2-1-30.47-20.87a3.45,3.45,0,0,1,0-2.78,3.32,3.32,0,0,1,2-2,3.84,3.84,0,0,1,2.81,0,3.4,3.4,0,0,1,2,2q6.48,15.54,24,16.27A4.08,4.08,0,0,1,216.41,125.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M199.49,184.25a2.06,2.06,0,0,1-1.61-.73,2.39,2.39,0,0,1-.69-1.72,2.26,2.26,0,0,1,.81-1.63,2,2,0,0,1,1.61-.65q10.88.39,20.52.7c1.59.05,3.16.11,4.73.18.8,0,1.59,0,2.36.07a2.14,2.14,0,0,1,.48.05l7.9.25q36.81,1.24,38.31,1.35a2.22,2.22,0,0,1,1.67.72,2.16,2.16,0,0,1,.59,1.69,2.24,2.24,0,0,1-.71,1.67,2.35,2.35,0,0,1-1.67.65q-1.55-.07-38.33-1.33l-7.89-.27a3.59,3.59,0,0,0-.47,0q-1.15-.06-2.37-.09L220,185Q210.36,184.66,199.49,184.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.26,133.24a7.24,7.24,0,0,1,4.84-3.4l-1.19,33.65a4,4,0,0,1-2.93-1.33,4.17,4.17,0,0,1-1.1-3l.85-9.15a2.89,2.89,0,0,1-1.89-1.22,3.56,3.56,0,0,1-.61-2.33l.21-7.33A10.84,10.84,0,0,1,263.26,133.24Zm-6.85-3.79,2.73.07-.28,8.55a5.18,5.18,0,0,1-1.38,3.4,5.77,5.77,0,0,1-3.07,1.89l-.12,17.21a2.62,2.62,0,0,1-.73,1.77,2.33,2.33,0,0,1-1.72.64,2,2,0,0,1-1.61-.78,2.42,2.42,0,0,1-.63-1.81l1.08-17.2a5.84,5.84,0,0,1-2.82-2.14,5.72,5.72,0,0,1-1-3.38l.28-8.52,2.54.07-.28,7.89a1.13,1.13,0,0,0,.23.79,1.2,1.2,0,0,0,.78.29.73.73,0,0,0,.69-.24,1.12,1.12,0,0,0,.37-.79l.28-7.88,2.62.07-.26,7.9a1,1,0,0,0,.3.82.85.85,0,0,0,.68.3.8.8,0,0,0,.74-.25,1.4,1.4,0,0,0,.35-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M190.11,171.15l131,4.54-.26,7.41-.25,7.5q-.23,5.52-5.85,5.34L195,191.81q-5.62-.21-5.39-5.73l.24-7.5Zm9.38,13.1q10.88.41,20.5.71l4.74.17q1.22,0,2.37.09a3.59,3.59,0,0,1,.47,0l7.89.27q36.79,1.26,38.33,1.33a2.35,2.35,0,0,0,1.67-.65,2.24,2.24,0,0,0,.71-1.67,2.16,2.16,0,0,0-.59-1.69,2.22,2.22,0,0,0-1.67-.72q-1.5-.1-38.31-1.35l-7.9-.25a2.14,2.14,0,0,0-.48-.05c-.77,0-1.56-.06-2.36-.07-1.57-.07-3.14-.13-4.73-.18q-9.65-.32-20.52-.7a2,2,0,0,0-1.61.65,2.26,2.26,0,0,0-.81,1.63,2.39,2.39,0,0,0,.69,1.72A2.06,2.06,0,0,0,199.49,184.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M321.06,175.69l-130.95-4.54,1.69-49.07q.22-5.52,5.81-5.3l119.74,4.14q5.59.18,5.39,5.68Zm-64.65-46.24-.26,7.89a1.4,1.4,0,0,1-.35.78.8.8,0,0,1-.74.25.85.85,0,0,1-.68-.3,1,1,0,0,1-.3-.82l.26-7.9-2.62-.07-.28,7.88a1.12,1.12,0,0,1-.37.79.73.73,0,0,1-.69.24,1.2,1.2,0,0,1-.78-.29,1.13,1.13,0,0,1-.23-.79l.28-7.89-2.54-.07-.28,8.52a5.72,5.72,0,0,0,1,3.38,5.84,5.84,0,0,0,2.82,2.14l-1.08,17.2a2.42,2.42,0,0,0,.63,1.81,2,2,0,0,0,1.61.78,2.33,2.33,0,0,0,1.72-.64,2.62,2.62,0,0,0,.73-1.77l.12-17.21a5.77,5.77,0,0,0,3.07-1.89,5.18,5.18,0,0,0,1.38-3.4l.28-8.55Zm6.85,3.79a10.84,10.84,0,0,0-1.82,5.86l-.21,7.33a3.56,3.56,0,0,0,.61,2.33,2.89,2.89,0,0,0,1.89,1.22l-.85,9.15a4.17,4.17,0,0,0,1.1,3,4,4,0,0,0,2.93,1.33l1.19-33.65A7.24,7.24,0,0,0,263.26,133.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.8,171l131,4.53-.28,7.42-.25,7.49q-.21,5.52-5.79,5.35l-119.74-4.14q-5.62-.23-5.39-5.74l.24-7.48Zm9.4,13.1q10.91.41,20.51.7,2.41.07,4.77.18l2.36.07a2.16,2.16,0,0,1,.46,0l7.85.26q36.84,1.23,38.35,1.33a2.38,2.38,0,0,0,1.7-.64,2.27,2.27,0,0,0,.72-1.7,2.27,2.27,0,0,0-2.28-2.4q-1.53-.09-38.35-1.33l-7.87-.25a1.64,1.64,0,0,0-.45-.05l-2.37-.11c-1.57,0-3.15-.1-4.77-.17q-9.6-.3-20.49-.67a2.06,2.06,0,0,0-1.65.65,2.24,2.24,0,0,0-.81,1.63,2.44,2.44,0,0,0,.69,1.72A2.24,2.24,0,0,0,195.2,184.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M316.75,175.56,185.8,171,187.49,122q.22-5.52,5.81-5.31L313,120.78c3.73.12,5.53,2,5.39,5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M195.2,184.13a2.24,2.24,0,0,1-1.63-.73,2.44,2.44,0,0,1-.69-1.72,2.24,2.24,0,0,1,.81-1.63,2.06,2.06,0,0,1,1.65-.65q10.89.38,20.49.67c1.62.07,3.2.13,4.77.17l2.37.11a1.64,1.64,0,0,1,.45.05l7.87.25q36.83,1.23,38.35,1.33a2.27,2.27,0,0,1,2.28,2.4,2.27,2.27,0,0,1-.72,1.7,2.38,2.38,0,0,1-1.7.64q-1.51-.1-38.35-1.33l-7.85-.26a2.16,2.16,0,0,0-.46,0l-2.36-.07q-2.35-.1-4.77-.18Q206.11,184.53,195.2,184.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M194.83,100.88l-34.57-4.66a.6.6,0,0,0-.23-.06,7.72,7.72,0,0,1-1.36-.35q-3.73-1.23-3.11-5.8l3.86-28.83q.75-5.35,6-4.77l.21,0,54,7.29q5.41.73,4.62,6.2l-3.87,28.84q-.74,5.47-6.15,4.74Zm14.8-24.32a2.63,2.63,0,0,0-2.07.51,2.91,2.91,0,0,0-1.1,1.87l-.75,5.47a2.57,2.57,0,0,0,.63,2.12,2.5,2.5,0,0,0,1.79,1.12,3,3,0,0,0,2.12-.58,2.88,2.88,0,0,0,1.08-1.93l.72-5.48a2.49,2.49,0,0,0-.54-2A2.58,2.58,0,0,0,209.63,76.56Zm-20.88,18a13,13,0,0,0,3.84-.18c1.16-.26,1.82-.68,2-1.26s.06-.84-.51-1l-9.72-1.28c-.61-.07-.9.18-.88.74s.62,1.16,1.68,1.72A11.66,11.66,0,0,0,188.75,94.59Zm-14-14.37.74-5.47a2.55,2.55,0,0,0-.58-2.06,2.47,2.47,0,0,0-1.84-1.09A2.8,2.8,0,0,0,169.88,74l-.75,5.51a2.71,2.71,0,0,0,.57,2.13,2.74,2.74,0,0,0,1.84,1.09,3,3,0,0,0,2.12-.56A2.8,2.8,0,0,0,174.73,80.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M209.63,76.56a2.58,2.58,0,0,1,1.88,1.08,2.49,2.49,0,0,1,.54,2l-.72,5.48a2.88,2.88,0,0,1-1.08,1.93,3,3,0,0,1-2.12.58,2.5,2.5,0,0,1-1.79-1.12,2.57,2.57,0,0,1-.63-2.12l.75-5.47a2.91,2.91,0,0,1,1.1-1.87A2.63,2.63,0,0,1,209.63,76.56Zm-34.9,3.66a2.8,2.8,0,0,1-1.07,1.91,3,3,0,0,1-2.12.56,2.74,2.74,0,0,1-1.84-1.09,2.71,2.71,0,0,1-.57-2.13l.75-5.51a2.8,2.8,0,0,1,3.17-2.36,2.47,2.47,0,0,1,1.84,1.09,2.55,2.55,0,0,1,.58,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M188.75,94.59a11.66,11.66,0,0,1-3.63-1.21c-1.06-.56-1.62-1.14-1.68-1.72s.27-.81.88-.74L194,92.2c.57.11.74.42.51,1s-.8,1-2,1.26A13,13,0,0,1,188.75,94.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M160,96.16l-12.58-1.68-19.95-2.7Q122,91,122.77,85.56l3.87-28.82q.78-5.46,6.25-4.75l32.54,4.42q-5.27-.58-6,4.77L155.56,90q-.63,4.58,3.11,5.8A7.72,7.72,0,0,0,160,96.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M191.9,104.41a38,38,0,0,1-3.12,2.72,27.19,27.19,0,0,1-8.21,4.33,25.68,25.68,0,0,1-11.39.86,28.28,28.28,0,0,1-6.26-1.58,6.62,6.62,0,0,0,2.35-4.31,6.95,6.95,0,0,0-5.87-7.71,6.77,6.77,0,0,0-5.15,1.38,6.29,6.29,0,0,0-2.08,2.67,5.74,5.74,0,0,1-.58-.69,26.66,26.66,0,0,1-4.14-7.6L160,96.16a.6.6,0,0,1,.23.06l34.57,4.66A26.78,26.78,0,0,1,191.9,104.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M180.57,111.46a27.19,27.19,0,0,0,8.21-4.33,38,38,0,0,0,3.12-2.72c.22.29.45.57.69.86a6.48,6.48,0,0,1,1.33,5,6.7,6.7,0,0,1-2.65,4.59,6.49,6.49,0,0,1-5.06,1.33,6.78,6.78,0,0,1-4.54-2.64A8.1,8.1,0,0,1,180.57,111.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M152.17,102.77a6.29,6.29,0,0,1,2.08-2.67,6.77,6.77,0,0,1,5.15-1.38,6.95,6.95,0,0,1,5.87,7.71,6.62,6.62,0,0,1-2.35,4.31,2,2,0,0,1-.29.26,6.61,6.61,0,0,1-5.1,1.32,6.77,6.77,0,0,1-4.56-2.61,7,7,0,0,1-1.31-5.1A8.86,8.86,0,0,1,152.17,102.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M184.77,136a1.08,1.08,0,0,1,.23-.82,1.11,1.11,0,0,1,.77-.49,1.71,1.71,0,0,1,.91.23,1.75,1.75,0,0,0,.39.3,5.94,5.94,0,0,0,3.52.85,1.19,1.19,0,0,1,.82.32,1.36,1.36,0,0,1,.44.86,1.52,1.52,0,0,1-.35.82,1.29,1.29,0,0,1-.81.39,8.44,8.44,0,0,1-5.45-1.6,1.58,1.58,0,0,1-.47-.79S184.74,136,184.77,136Zm3.68-4.48a6.41,6.41,0,0,0,3,.59,1.08,1.08,0,0,1,.86.32,1.13,1.13,0,0,1,.33.81,1,1,0,0,1-.24.82,1.55,1.55,0,0,1-.86.38,9.22,9.22,0,0,1-3.4-.5,6.52,6.52,0,0,1-2-1.14,1.08,1.08,0,0,1-.46-.72,1.21,1.21,0,0,1,.21-.91,1.13,1.13,0,0,1,.78-.44,1,1,0,0,1,.85.23A6.37,6.37,0,0,0,188.45,131.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M188.45,131.52a6.37,6.37,0,0,1-1-.56,1,1,0,0,0-.85-.23,1.13,1.13,0,0,0-.78.44,1.21,1.21,0,0,0-.21.91,1.08,1.08,0,0,0,.46.72,6.52,6.52,0,0,0,2,1.14,3.69,3.69,0,0,1-1,1.28,1.75,1.75,0,0,1-.39-.3,1.71,1.71,0,0,0-.91-.23,1.11,1.11,0,0,0-.77.49,1.08,1.08,0,0,0-.23.82l-.45-.1q-22-3.28-28.18-23.83a3.62,3.62,0,0,1,.34-2.85,3.4,3.4,0,0,1,2.13-1.76,3.67,3.67,0,0,1,2.86.3,3.57,3.57,0,0,1,1.75,2.19q4.82,16.13,22.13,18.68a3.58,3.58,0,0,1,2.43,1.45A3.66,3.66,0,0,1,188.45,131.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M272.67,137.48a9.54,9.54,0,0,1,6.94,3.18,9.66,9.66,0,0,1,2.64,7.17,9.49,9.49,0,0,1-3.19,6.92,10,10,0,1,1-13.57-14.63A9.56,9.56,0,0,1,272.67,137.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M272.6,135l-40.75-1.58a12.25,12.25,0,0,0-9.18,3.38,12.76,12.76,0,0,0,8.18,22.15l40.75,1.57a12.25,12.25,0,0,0,9.16-3.34v0A12.78,12.78,0,0,0,272.6,135Zm-52.7-1.16,0,0A16.2,16.2,0,0,1,232,129.4L272.76,131a16.79,16.79,0,0,1-1.32,33.56L230.69,163a16.83,16.83,0,0,1-10.79-29.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M420.89,504.73h10.58q.58,5.4,6.4,8.87c4.35,2.56,6.5,4.19,6.43,4.88a2.72,2.72,0,0,1-.34,1.42h-6.55q-4.61.18-6.52-1.71c-1.31-1.3-2.18-1.91-2.63-1.83v3.54h-4l-3.08-6.81A13.08,13.08,0,0,1,420.89,504.73Zm-21,0h10.57a13.5,13.5,0,0,1-.3,8.36l-3.05,6.81h-4v-3.54c-.42-.08-1.29.53-2.62,1.83S397,520,393.92,519.9h-6.55a2.44,2.44,0,0,1-.35-1.42c0-.69,2.06-2.32,6.33-4.88Q399.22,510.12,399.86,504.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M401,312a1,1,0,0,1,.86.29,1.37,1.37,0,0,1,.38.86l.13,2.63a1.08,1.08,0,0,1-.3.88,1.56,1.56,0,0,1-.86.42,1.19,1.19,0,0,1-.86-.35,1.35,1.35,0,0,1-.44-.81l-.08-2.7a1,1,0,0,1,.24-.87A1.35,1.35,0,0,1,401,312ZM416,310.87a1.27,1.27,0,0,1,.86.3,1.24,1.24,0,0,1,.37.86l.14,2.64a1,1,0,0,1-.32.86,1.11,1.11,0,0,1-.86.39,1.34,1.34,0,0,1-.86-.27,1.23,1.23,0,0,1-.36-.86l-.16-2.66a1.21,1.21,0,0,1,1.19-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M411.16,330.32a7.81,7.81,0,0,1,.43,1.49,4.83,4.83,0,0,1-4.61-.3c-.52-.31-1.25-.17-2.19.4a4.32,4.32,0,0,0-.53.35,3.67,3.67,0,0,1-3.4.81,9.86,9.86,0,0,1-2.75-1.44,6.49,6.49,0,0,0-2.05-.93c-.77-.23-1.7-.45-2.78-.66q-3.63-.69-3.45-5c.11-2.84-.2-4.77-.95-5.8a.31.31,0,0,1,0-.09c-1.36-2.39-1.51-4.51-.43-6.34a3.79,3.79,0,0,0,.43-.88,6.61,6.61,0,0,0,.13-4.55l-.13-.42c-.57-1.82-.57-3.25,0-4.28a3,3,0,0,1,2-1.42,3.36,3.36,0,0,0,2.63-3.41c0-2.7,1.77-4.59,5.42-5.66q4.14-.84,5.09-2.53c1.81-2.83,4.74-3.38,8.78-1.62,2.07.88,3.62.9,4.66,0q3.11-2.49,6.43,1l.62.72a.84.84,0,0,0,.35.28v.07a1.33,1.33,0,0,0,.75.14,6.63,6.63,0,0,1,2.89-.33,4.93,4.93,0,0,1,2.58.85q1.2.69,2.52,3.75a6.36,6.36,0,0,0,4.08,3.86,3.73,3.73,0,0,1,2.72,3.9,7.94,7.94,0,0,0,2,5.42q2.07,2.42.86,4.73c-.8,1.53-.4,3.39,1.23,5.57s1.91,4.19.79,6.13a25.6,25.6,0,0,0-1.95,4.33c-.61,1.65-1.58,2.43-2.92,2.35a9,9,0,0,0-4.54,1.05,8.21,8.21,0,0,1-5.12.7,9.24,9.24,0,0,0-4-.09h0a19,19,0,0,1-2.05.53l-1.11.23c-.4,0-.78.07-1.13.07h-.55a4.93,4.93,0,0,0-.66-.07,1.64,1.64,0,0,1-.42-.06.14.14,0,0,0-.09-.05.44.44,0,0,0-.19-.05A1.63,1.63,0,0,1,420,333a3.34,3.34,0,0,1-1.11-1,.44.44,0,0,0-.12-.19,5.14,5.14,0,0,1-.35-1.18q0-.46,0-1.17c0-.22,0-.46,0-.7l.21-.74a10.36,10.36,0,0,1,3.42-4.36.22.22,0,0,1,.07-.12q1.66-2-.46-4.89-2.29-2.49-.52-4.43a9.82,9.82,0,0,0,1.38-5.82,7.14,7.14,0,0,0-2.19-4.57q-4.31-4.11,0-7.68c-2.55,1.3-4.47,1.68-5.77,1.16q-1.38-.57-3.83,2c-1.62,1.75-3.21,2.27-4.79,1.54-1.26-.34-2.26.2-3,1.61a2.63,2.63,0,0,1-3.49,1.48c-1.37-.61-2.22.09-2.52,2.1l1.14,14q.65,6.86,5.64,9.17a15.71,15.71,0,0,0,7.34,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M418.4,328.69a34.38,34.38,0,0,1-7.24,1.63H411a15.71,15.71,0,0,1-7.34-1.14q-5-2.31-5.64-9.17l-1.14-14c.3-2,1.15-2.71,2.52-2.1a2.63,2.63,0,0,0,3.49-1.48c.75-1.41,1.75-1.95,3-1.61,1.58.73,3.17.21,4.79-1.54s2.91-2.41,3.83-2c1.3.52,3.22.14,5.77-1.16q-4.33,3.57,0,7.68a7.14,7.14,0,0,1,2.19,4.57,9.82,9.82,0,0,1-1.38,5.82q-1.77,1.94.52,4.43,2.13,2.94.46,4.89a.22.22,0,0,0-.07.12,10.36,10.36,0,0,0-3.42,4.36ZM401,312a1.35,1.35,0,0,0-.93.35,1,1,0,0,0-.24.87l.08,2.7a1.35,1.35,0,0,0,.44.81,1.19,1.19,0,0,0,.86.35,1.56,1.56,0,0,0,.86-.42,1.08,1.08,0,0,0,.3-.88l-.13-2.63a1.37,1.37,0,0,0-.38-.86A1,1,0,0,0,401,312Zm4.8,13.89.37.24a2.86,2.86,0,0,0,1.16.48,8.82,8.82,0,0,0,2.2.17q3.31-.23,4.23-2.42c0-.11.17-.4.38-.85a8.78,8.78,0,0,0,.3-.91v-.13a3.05,3.05,0,0,0,.05-.45.84.84,0,0,0-.84-.88l-4.49.25-4.45.21a1,1,0,0,0-.49.24,1.21,1.21,0,0,0-.12,1.19l0,0a7.11,7.11,0,0,0,.52,1.31c.24.43.39.69.48.81A2.8,2.8,0,0,0,405.75,325.85Zm10.25-15a1.21,1.21,0,0,0-1.19,1.26l.16,2.66a1.23,1.23,0,0,0,.36.86,1.34,1.34,0,0,0,.86.27,1.11,1.11,0,0,0,.86-.39,1,1,0,0,0,.32-.86l-.14-2.64a1.24,1.24,0,0,0-.37-.86A1.27,1.27,0,0,0,416,310.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M431.47,504.73H420.89q1.31-4.07.1-17.66t.55-20.74q1.71-7.26-1.05-18.63h14.77a375,375,0,0,0-3.84,55.89C431.42,504,431.44,504.38,431.47,504.73ZM370,339.87a.64.64,0,0,0-.28.05l-.28.17-5.34,2.42-.12,0q-2.66.34-4.23-5.35l-.75-3,0,0v-.05l-.8-2.92v-.07l-.42-1.44a1,1,0,0,1,.12-.88,1.15,1.15,0,0,1,.77-.58,1.18,1.18,0,0,1,.91.13,1.1,1.1,0,0,1,.56.7,1.28,1.28,0,0,1,.18-.91,1.15,1.15,0,0,1,.72-.55,1.27,1.27,0,0,1,1,.07,1.35,1.35,0,0,1,.56.74,1.31,1.31,0,0,1,.12-.91,1.21,1.21,0,0,1,.77-.56,1.31,1.31,0,0,1,.92.09,1.23,1.23,0,0,1,.61.73L363,320.93a1,1,0,0,1,.12-.86,1.15,1.15,0,0,1,.77-.63,1.19,1.19,0,0,1,.91.12,1.33,1.33,0,0,1,.62.75l2.06,7.59c1-.4,1.7-.14,2,.79l1.21,4.45a10.55,10.55,0,0,1,.06,4.71,2,2,0,0,0-.11.21A6.68,6.68,0,0,1,370,339.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M430,381.09a21,21,0,0,0-1.66,1.45l-.06.09a3.88,3.88,0,0,0-.42,4.43,2.49,2.49,0,0,0,1.44,2.49c-.07.68.57,1.35,1.91,2,.19.57.81.86,1.86.86a5.81,5.81,0,0,0,1-.09l.29,1.88a72,72,0,0,1-11-1.14q-11.34-2.3-10.18-15.53v-.17a146.8,146.8,0,0,1,4.54-24.57q3-10.07,4.48-17.41c.05-.25.09-.5.13-.75s.07-.41.12-.65v-.05a5.86,5.86,0,0,1,.79.05,2.11,2.11,0,0,1,.35,0,2.21,2.21,0,0,0,.5.15,19.8,19.8,0,0,1,4.74,1.39,24.82,24.82,0,0,1,3.8,1.84c1.49.88,3,1.82,4.43,2.8,1,.6,2,1.26,3.05,2q9.25,6.25,18.62,14a13.79,13.79,0,0,1,4.15,6.05q1.32,4.31-3.67,8.27l-15.37,12.61c-.61.43-1.11.49-1.51.18l-.15-.25L438,378l-.19-.26a.27.27,0,0,1-.05-.18c-.24-.42-.1-.83.42-1.22l9.7-7.52q4.36-3.23,4.08-4.05,0-2.57-13.17-9.95a10.14,10.14,0,0,1-1.33-.73l-6.31-3.38L426.07,369a8.94,8.94,0,0,0,.21,5.41,10.78,10.78,0,0,0,1.27,2.63Zm-19-47.79a1.59,1.59,0,0,0-.16.57V334q-2.08,6.61-2.94,19a168.43,168.43,0,0,0,.4,24.51c.05.56.1,1.1.17,1.6q1.24,13.06-16.43,13.28a47.9,47.9,0,0,1,4.43-14.88c.56-1,1.14-2,1.72-3,0-.07,0-.11.11-.13.25-.44.5-.89.73-1.36a22.91,22.91,0,0,0,1.84-3.65q.75-1.77-.51-8A34.81,34.81,0,0,1,398.62,351l-.49.86a8.22,8.22,0,0,1-.47.75,58,58,0,0,1-3.35,5c-.26.32-.54.66-.86,1a2.92,2.92,0,0,1-.47.42,31,31,0,0,1-12.07,8.62,8.89,8.89,0,0,1-2.39.48q-4.45.25-7.2-5.61l-8.27-18c-.35-.73-.29-1.23.18-1.49l.21-.18.65-.28,5.34-2.42.28-.17a.64.64,0,0,1,.28-.05c.43,0,.76.25,1,.78l4.85,11.22q2,5,3,5,3.68,1.42,8.67-6.46t5.19-8.18a24,24,0,0,1,4.94-5.35,11,11,0,0,1,3-1.52.89.89,0,0,0,.4-.12H401Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M409.11,321.35a6.38,6.38,0,0,0-3.36,4.5,2.8,2.8,0,0,1-.66-.72c-.09-.12-.24-.38-.48-.81a7.11,7.11,0,0,1-.52-1.31l0,0a1.21,1.21,0,0,1,.12-1.19,1,1,0,0,1,.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M405.75,325.85a6.38,6.38,0,0,1,3.36-4.5l4.49-.25a.84.84,0,0,1,.84.88,3.05,3.05,0,0,1-.05.45v.13a8.78,8.78,0,0,1-.3.91c-.21.45-.34.74-.38.85q-.91,2.19-4.23,2.42a8.82,8.82,0,0,1-2.2-.17,2.86,2.86,0,0,1-1.16-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M411.59,331.81a7.81,7.81,0,0,0-.43-1.49,34.38,34.38,0,0,0,7.24-1.63c0,.24,0,.48,0,.7q0,.71,0,1.17a5.14,5.14,0,0,0,.35,1.18.44.44,0,0,1,.12.19,3.34,3.34,0,0,0,1.11,1,1.63,1.63,0,0,0,.51.18.44.44,0,0,1,.19.05.14.14,0,0,1,.09.05,1.64,1.64,0,0,0,.42.06,4.93,4.93,0,0,1,.66.07h.55l.05.56V334c-.05.24-.09.46-.12.65a.53.53,0,0,1-.23.21q-3.62,3.27-7.66,2.61a3.93,3.93,0,0,1-3.63-3.47.23.23,0,0,1,0-.11,1.59,1.59,0,0,1,.16-.57.7.7,0,0,0,.4-.41A1.32,1.32,0,0,0,411.59,331.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M410.81,447.7H396a310.75,310.75,0,0,1-4-55.29q17.68-.21,16.43-13.28c-.07-.5-.12-1-.17-1.6a168.43,168.43,0,0,1-.4-24.51q.86-12.42,2.94-19v-.11a.23.23,0,0,0,0,.11,3.93,3.93,0,0,0,3.63,3.47q4.05.66,7.66-2.61a.53.53,0,0,0,.23-.21c0,.25-.08.5-.13.75q-1.51,7.33-4.48,17.41a146.8,146.8,0,0,0-4.54,24.57v.17q-1.15,13.23,10.18,15.53a72,72,0,0,0,11,1.14,187.17,187.17,0,0,1,.86,53.5H410.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M430,381.09c1-.67,1.95-1.32,3-2q2.82-2,5.08-1.16l4.14,5c.26,1.19-1.3,3.06-4.68,5.59q.94,2.37-1.53,3.45a9.63,9.63,0,0,1-1.92.3,5.81,5.81,0,0,1-1,.09c-1.05,0-1.67-.29-1.86-.86-1.34-.65-2-1.32-1.91-2a2.49,2.49,0,0,1-1.44-2.49,3.88,3.88,0,0,1,.42-4.43l.06-.09A21,21,0,0,1,430,381.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M410.43,504.73H399.86c0-.35,0-.73,0-1.14A379.82,379.82,0,0,0,396,447.7h14.82q-2.74,11.37-1,18.63,1.64,7.11.53,20.74T410.43,504.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M358.42,423.14q.65,6.15-2.93,14.7c-1,2.41-1.81,2.21-2.47-.62a6,6,0,0,0-5.34-4.9q-4.6-.69-3.38-2.12,6.82-7.33,12.47-8.06C357.87,422,358.42,422.3,358.42,423.14Zm-30.8,5.46a56.62,56.62,0,0,1,3.26-10.07c1.16-2.82,2-3.58,2.41-2.3q1.11,3.79-.22,11.65a21.9,21.9,0,0,0-4.61.51Q328,428.48,327.62,428.6Zm5,17.35c-1.14-1.3-1.5-2.05-1.05-2.25.17-.11.81.06,1.91.51a5.47,5.47,0,0,1-.16.7A1.73,1.73,0,0,1,332.61,446ZM318.24,442l.44-1.66c.16-.55.38-.65.65-.28a6,6,0,0,1-.46,1A2.86,2.86,0,0,1,318.24,442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M314.14,444.07a10.79,10.79,0,0,1,2.47.69.35.35,0,0,1,.18.05l.51.26c1.28.69,1.42,1.54.42,2.54a4,4,0,0,1-3.87,1.09,2.09,2.09,0,0,1-1.72-1.89,3.65,3.65,0,0,1-.14-.67v-.42l.09-.65a1,1,0,0,1,.17-.38,1.23,1.23,0,0,1,1.26-.65h.13Zm4.91,12a15,15,0,0,1-6.06-1.49,3,3,0,0,1-1.82-3.34q0,2.72,6,3.69a34,34,0,0,0,10.56.3q4.61-.69-2.54,3.37a4.29,4.29,0,0,0,1.12-.91q1.83-1.85-4.17-1.62C321,456.09,320,456.09,319.05,456.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M347.62,515.77a5.09,5.09,0,0,0-.73,3.1c.07.33.14.69.23,1h-8.83c1.12-.31,1.84-1.4,2.15-3.3a4,4,0,0,1,.09-.52,6.14,6.14,0,0,1,.12-.86c.12-.76.24-1.54.37-2.33A19.07,19.07,0,0,0,347.62,515.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M350.85,509.16a3.41,3.41,0,0,1,.33,2.7,3.62,3.62,0,0,1-.79,1.26l-.24.24a9,9,0,0,1-.79.67,6,6,0,0,0-1.74,1.74,19.07,19.07,0,0,1-6.6-2.86c.15-.84.3-1.71.46-2.59l1-6.91A19.54,19.54,0,0,0,350.85,509.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M361,461.84q-3.1-2.77-11.3-4.49t-6.85-3.45q6.46-14.1-1.16-19.81-8.28-4.69-15,.89.64-4.31-2.25-5a14.85,14.85,0,0,1,1.83-.91l0,0a4.9,4.9,0,0,1,1.17-.4.41.41,0,0,1,.2-.09q.4-.12.84-.21a21.9,21.9,0,0,1,4.61-.51c1,0,2.1.08,3.18.2.92.11,1.83.25,2.74.4s1.61.31,2.38.51a7.34,7.34,0,0,0,.84.17c.51-.65,1-1.3,1.56-1.94q6.5-7.28,15.47-7a1.9,1.9,0,0,1,.63.11.87.87,0,0,1,.35.07c1.18.37,1.75,1.42,1.72,3.15a162.18,162.18,0,0,1-2.45,25.42c0,.24-.13,1.79-.37,4.66C358.67,457,359.29,459.71,361,461.84Zm-2.54-38.7c0-.84-.55-1.18-1.65-1q-5.64.74-12.47,8.06-1.23,1.43,3.38,2.12a6,6,0,0,1,5.34,4.9c.66,2.83,1.48,3,2.47.62Q359.06,429.29,358.42,423.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M333.07,427.88q1.32-7.86.22-11.65c-.44-1.28-1.25-.52-2.41,2.3a56.62,56.62,0,0,0-3.26,10.07.41.41,0,0,0-.2.09,4.9,4.9,0,0,0-1.17.4q3.09-11,5.57-13.75a5.26,5.26,0,0,1,.44-.49q2.13-1.75,4.43,2.42A45.77,45.77,0,0,1,341.37,429c-.77-.2-1.56-.37-2.38-.51s-1.82-.29-2.74-.4C335.17,428,334.1,427.9,333.07,427.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M348.54,469.13l-30.12,1.26a68,68,0,0,0-5.7-9.85q-4.43-6.77-4-9a15.38,15.38,0,0,1,3.24-5.82v.42a3.65,3.65,0,0,0,.14.67,2.09,2.09,0,0,0,1.72,1.89,4,4,0,0,0,3.87-1.09c1-1,.86-1.85-.42-2.54l-.51-.26a.35.35,0,0,0-.18-.05,10.79,10.79,0,0,0-2.47-.69,1.23,1.23,0,0,0-.29,0,11.11,11.11,0,0,0,2.27-3.1q2.58-7.89,8.27-11,2.89.72,2.25,5,6.72-5.6,15-.89,7.62,5.7,1.16,19.81-1.44,1.77,6.85,3.45t11.3,4.49a8,8,0,0,0,.72.8,7.59,7.59,0,0,1-3.58,1.72l3.58.91A26,26,0,0,1,348.54,469.13ZM332.61,446a1.73,1.73,0,0,0,.7-1,5.47,5.47,0,0,0,.16-.7,6.05,6.05,0,0,0-.28-1.77c-.22-1-.68-1.48-1.37-1.5a3.25,3.25,0,0,0-2.15.82,3.2,3.2,0,0,0-1.3,1.79,2.22,2.22,0,0,0,.12,1.64,2.74,2.74,0,0,0,1.47,1,3.65,3.65,0,0,0,2.07,0ZM318.24,442a2.86,2.86,0,0,0,.63-1,6,6,0,0,0,.46-1c.14-.39.28-.82.42-1.28.22-.83.18-1.22-.14-1.16a2.39,2.39,0,0,0-1.31,1,8.61,8.61,0,0,0-1.32,1.91,4.38,4.38,0,0,0-.52,1.42.65.65,0,0,0,.35.7c.27.11.61,0,1-.33ZM313,454.58l1.57,3.93c.93,2.32,2.67,3.09,5.23,2.29a40.2,40.2,0,0,0,4.73-1.85,3,3,0,0,0,.4-.23l.17-.07a.11.11,0,0,1,.09,0q7.15-4.07,2.54-3.37a34,34,0,0,1-10.56-.3q-5.94-1-6-3.69A3,3,0,0,0,313,454.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M333.47,444.21c-1.1-.45-1.74-.62-1.91-.51-.45.2-.09.95,1.05,2.25l-.58.24a3.65,3.65,0,0,1-2.07,0,2.74,2.74,0,0,1-1.47-1,2.22,2.22,0,0,1-.12-1.64,3.2,3.2,0,0,1,1.3-1.79,3.25,3.25,0,0,1,2.15-.82c.69,0,1.15.52,1.37,1.5A6.05,6.05,0,0,1,333.47,444.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M334.22,473.91l-15.54.93a.5.5,0,0,1-.61-.53l-.18-3.34c0-.38.14-.57.53-.58l30.12-1.26.17,3.34a.5.5,0,0,1-.51.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M368.28,489.29a13.26,13.26,0,0,1,5.05,11.13A22.21,22.21,0,0,0,366,493a15.7,15.7,0,0,0-8.19-2.07q-5.39.12-7.83,2.42-4.59,4.26.88,15.82a19.54,19.54,0,0,1-8.39-5.75l-1,6.91-2.72,3.1-2.3-3.35-3,2.84-1.58-3.07-2.73,2.84L328,509.49c.08-.49.16-1,.23-1.49,0-.19,0-.41,0-.64v-1a4.12,4.12,0,0,0,0-.86,20.88,20.88,0,0,0-.33-3.34,16.21,16.21,0,0,0-.53-2.3,24.85,24.85,0,0,1-.66-3.1q-1.36-8.49,1.61-14.05a48.77,48.77,0,0,1,5.85-8.83l14-.82q3.53,7.57,16.1,13.7A21.36,21.36,0,0,1,368.28,489.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M367.86,519.92q-1.32-1.33,5.12-3.7,3.67-.91,8.23-6.94t1.79-4.83q-4.08,1.73-2-3.82c1.41-3.72,1.37-5.14-.13-4.28s-3.35-1.56-5.57-7.27q-3.78-8.74-6.8-11.86a23.8,23.8,0,0,1,4.84,3.66,54.43,54.43,0,0,1,8.18,9.18c.83,1.35,1.79,1.36,2.87.06q1.1-.18,3.28,4.43t-1.28,11.26a6.19,6.19,0,0,0-.05,4.89q.94,2.66-8,4.49c-2.28.51-3.28,1.34-3,2.48.46,1.38-1.6,2.13-6.16,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M319.33,440.1c-.27-.37-.49-.27-.65.28l-.44,1.66-.4.3c-.42.33-.76.44-1,.33a.65.65,0,0,1-.35-.7,4.38,4.38,0,0,1,.52-1.42,8.61,8.61,0,0,1,1.32-1.91,2.39,2.39,0,0,1,1.31-1c.32-.06.36.33.14,1.16C319.61,439.28,319.47,439.71,319.33,440.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M314.56,458.51c.19-1.2,1.69-2,4.49-2.44,1,0,2,0,3.08,0q6-.22,4.17,1.62a4.29,4.29,0,0,1-1.12.91.11.11,0,0,0-.09,0l-.17.07a3,3,0,0,1-.4.23,40.2,40.2,0,0,1-4.73,1.85C317.23,461.6,315.49,460.83,314.56,458.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M314.56,458.51,313,454.58a15,15,0,0,0,6.06,1.49C316.25,456.49,314.75,457.31,314.56,458.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M318.68,474.84l15.54-.93a48.77,48.77,0,0,0-5.85,8.83q-3,5.55-1.61,14.05a24.85,24.85,0,0,0,.66,3.1,16.21,16.21,0,0,1,.53,2.3,20.88,20.88,0,0,1,.33,3.34q-7.71-9.6-9.23-25.3c0-.26,0-.52-.07-.77l-.11-1.64a1.22,1.22,0,0,0,0-.21l-.16-1.86C318.7,475.47,318.69,475.16,318.68,474.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M319.05,480.23q1.53,15.7,9.23,25.3a4.12,4.12,0,0,1,0,.86v1c0,.23,0,.45,0,.64-.07.51-.15,1-.23,1.49-.12.81-.27,1.61-.47,2.42l-1.33-2.15-2.41,3.6L322.48,509a75.25,75.25,0,0,0-1.66-12.86A141,141,0,0,1,319.05,480.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M327.55,511.91a28.85,28.85,0,0,1-1.84,4.78c-1.16,2,.16,3.11,4,3.23h-6.49q-2.61-.2-1.45-3.52a40.36,40.36,0,0,0,.75-7.36l1.33,4.32,2.41-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M341,512.91c-.13.79-.25,1.57-.37,2.33a6.14,6.14,0,0,0-.12.86,4,4,0,0,0-.09.52c-.31,1.9-1,3-2.15,3.3h-8.62c-3.8-.12-5.12-1.19-4-3.23a28.85,28.85,0,0,0,1.84-4.78c.2-.81.35-1.61.47-2.42l1.16,3.19,2.73-2.84,1.58,3.07,3-2.84,2.3,3.35,2.72-3.1C341.32,511.2,341.17,512.07,341,512.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M368.79,514.5q4.36-8.06,4.54-14.08a13.26,13.26,0,0,0-5.05-11.13q2.19-3.42.26-12.07,3,3.12,6.8,11.86,3.33,8.57,5.57,7.27c1.5-.86,1.54.56.13,4.28s-.76,5,2,3.82q2.82-1.21-1.79,4.83T373,516.22q-6.44,2.37-5.12,3.7h-2.24c.85-.25,1.64-1.28,2.36-3.1a2.31,2.31,0,0,1,.18-.35C368.38,515.88,368.59,515.23,368.79,514.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M351.18,511.86a3.41,3.41,0,0,0-.33-2.7q-5.48-11.57-.88-15.82,2.44-2.29,7.83-2.42A15.7,15.7,0,0,1,366,493a22.21,22.21,0,0,1,7.34,7.43q-.18,6-4.54,14.08l-1.26,1.11-1.89-2.25L363.5,515l-2.68-2.1-3.66,1.66-2-2.36-4,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M347.12,519.92c-.09-.36-.16-.72-.23-1a5.09,5.09,0,0,1,.73-3.1,6,6,0,0,1,1.74-1.74,9,9,0,0,0,.79-.67l.24-.24a3.62,3.62,0,0,0,.79-1.26v1.79l4-1.44,2,2.36,3.66-1.66,2.68,2.1,2.14-1.65,1.89,2.25,1.26-1.11c-.2.73-.41,1.38-.63,2a2.31,2.31,0,0,0-.18.35c-.72,1.82-1.51,2.85-2.36,3.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "83.17 353.79 101.42 353.79 93.92 341.88 94.08 319.61 72.25 329.29 83.17 353.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M137.46,329.4q8,.35,8.25-2.37c.15-1.41-.05-2-.59-1.64a3.78,3.78,0,0,1-1,.43q.7,2.49-2.92,2.79C138.79,328.82,137.54,329.08,137.46,329.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M139.88,315a.82.82,0,0,0-.32.61.76.76,0,0,0,.21.53s.07.05.11.12a2.22,2.22,0,0,0,.37.21h2.41a.78.78,0,0,0,.56-.21.85.85,0,0,0,.3-.65.83.83,0,0,0-.3-.61.73.73,0,0,0-.56-.24h-2.19A.81.81,0,0,0,139.88,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M136.67,304.52a58.33,58.33,0,0,0,8.45.21q14-.42,17.94,2.17t1.5,12.56a38.11,38.11,0,0,0,3.35-7.41,8.46,8.46,0,0,0,.44-1.63q1.16-6.68-.44-10.63-2.07-5-8.69-5.64a49.86,49.86,0,0,0-8.11,0c-1.15.08-2.28.19-3.4.33q-14,1.13-2.24-5.17-8.33,1.68-13.23,5.29c-.38.28-.72.56-1,.83l0,.05c-.49.42-1,.85-1.38,1.28a4.15,4.15,0,0,0-.46.56q-3.18,3.56.46,5.45a14.35,14.35,0,0,0,2.77,1A30.13,30.13,0,0,0,136.67,304.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M137,314.17l-.3-9.65a58.33,58.33,0,0,0,8.45.21q8.46.45,7.84,12.77-.35,4.74-7.62,4.7h-8.06Zm2.59,1.47a.76.76,0,0,0,.21.53s.07.05.11.12a2.22,2.22,0,0,0,.37.21h2.41a.78.78,0,0,0,.56-.21.85.85,0,0,0,.3-.65.83.83,0,0,0-.3-.61.73.73,0,0,0-.56-.24h-2.19a.81.81,0,0,0-.59.24A.82.82,0,0,0,139.56,315.64Zm2.68,10.48H138c-.59,0-.82-.63-.71-2H146c1.39.07,1.45,2.18.17,6.31-1,2.8-2.06,3.39-3.1,1.75a3.61,3.61,0,0,0-3.2-1.4h-2.41l0-1.38q8,.35,8.25-2.37c.15-1.41-.05-2-.59-1.64a3.78,3.78,0,0,1-1,.43A13.42,13.42,0,0,1,142.24,326.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M137.28,322.2l-.31-8-2.59,4.42Q132.79,321.23,137.28,322.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M144.87,340.45a7.56,7.56,0,0,1,1.81-2q.76-.64,1.8-1.38a33.41,33.41,0,0,1,4.27-2.37l2.16-1q1.47-4.89,1.89-15.9v-.33a5.75,5.75,0,0,1,1.51-3.8,2.78,2.78,0,0,1,1.94-1,2.88,2.88,0,0,1,2.68,1.21,5.4,5.4,0,0,1-.1,6.37,4.26,4.26,0,0,1-2.8,1.44l-.13,0c.12,3.59,1,5.49,2.68,5.67a28.75,28.75,0,0,1,2-7.92q2.43-10-1.5-12.56t-17.94-2.17q8.46.45,7.84,12.77-.35,4.74-7.62,4.7h-8.06v1.92H146c1.39.07,1.45,2.18.17,6.31-1,2.8-2.06,3.39-3.1,1.75a3.61,3.61,0,0,0-3.2-1.4h-2.41q-.59,11.28,6.47,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M91.54,340.79l6.73-4a20,20,0,0,1-1.28-5.6q-.28-3.66-.79-7.71a1.15,1.15,0,0,0,0-.33,4.29,4.29,0,0,0-1.89-2.88l-4.87-.68-2.66-.37a2.21,2.21,0,0,0-1,.37,1.53,1.53,0,0,0-.74,1.21,1.62,1.62,0,0,0,0,.44,1.42,1.42,0,0,0,.35.77.66.66,0,0,1,.16.31h-.46a4.61,4.61,0,0,1-.4.35,1.4,1.4,0,0,0-.63,1.11,1.43,1.43,0,0,0,.26,1.26,2.72,2.72,0,0,0,.42.51.58.58,0,0,1,.39.22,1.4,1.4,0,0,0-.86,1.28,1.14,1.14,0,0,0,.17.81,2.5,2.5,0,0,0,.69.63,2.66,2.66,0,0,0-.56.81,3.06,3.06,0,0,0,.43,1.08,1.49,1.49,0,0,0,1,.63,2.89,2.89,0,0,0,1.24.23,25.44,25.44,0,0,1,1.09,5.82,6.82,6.82,0,0,0,.12.86A4.37,4.37,0,0,0,91.54,340.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M85.39,322.06a.66.66,0,0,1,.16.31h-.46a4.61,4.61,0,0,1-.4.35,1.4,1.4,0,0,0-.63,1.11,1.43,1.43,0,0,0,.26,1.26,2.72,2.72,0,0,0,.42.51.58.58,0,0,1,.39.22,1.4,1.4,0,0,0-.86,1.28,1.14,1.14,0,0,0,.17.81l-4.69,1.79a2.68,2.68,0,0,1-1.3.17H77.33a5.72,5.72,0,0,1-1.44-4.54l.67-.54a3.12,3.12,0,0,1,1.07-.74L85,321.29A1.42,1.42,0,0,0,85.39,322.06Zm16.33-7a3,3,0,0,1,2.33.11,2.87,2.87,0,0,1,1.56,1.66,2.92,2.92,0,0,1-.11,2.3,2.79,2.79,0,0,1-1.66,1.57l-7.64,2.86a1.15,1.15,0,0,0,0-.33,4.29,4.29,0,0,0-1.89-2.88l-4.87-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M151.41,404.17q17.28-2,28.1-5.23c3.14-1.08,5.72-1.29,7.72-.64q5.57-3.51.62-20.51c-1-3.42-2-6.86-2.91-10.3-.2-.81-.42-1.62-.65-2.42q-2.81-10.69-5.17-21.52a20.88,20.88,0,0,0-.65-2.43l-2.87-.18v.6a10.29,10.29,0,0,1-.28,1.56,10.06,10.06,0,0,1-.37,1.72,5.89,5.89,0,0,1-.44,1.13,6,6,0,0,1-.68,1.23,3.4,3.4,0,0,1-.75,1q-9,6.39-19.38.64c-.92-.52-1.84-1.09-2.77-1.72a.29.29,0,0,0-.17-.07,6.73,6.73,0,0,0-2-.91,7.76,7.76,0,0,0-2.17-.28,13,13,0,0,0-2.87.45l-26.76,7.19a4.13,4.13,0,0,1-4.48-1.72l-8-10.18c-1-1.43-2-2-3-1.84l-8.85,5.17c-.59.51-.41,1.51.56,3l11.39,15.23q4.14,5.55,13,3.66l21-3.82c1.3-.19,2.25.46,2.86,1.95a11.44,11.44,0,0,1,.77,3.34q.62,5.7.79,12.63a69.54,69.54,0,0,0,1.73,13.58A14.45,14.45,0,0,0,151.41,404.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M92.57,344.87l8.85-5.17-1.33-2.24a1.38,1.38,0,0,0-1.82-.62l-6.73,4h-.07c-.81.46-.88,1.11-.23,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M77.33,329.87a5.72,5.72,0,0,1-1.44-4.54l-3.1,2.74c-.51.48-.69.88-.54,1.22s.53.55,1.23.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M154.91,333.73l-2.16,1a33.41,33.41,0,0,0-4.27,2.37q-1,.74-1.8,1.38a7.56,7.56,0,0,0-1.81,2,8.78,8.78,0,0,0-1.17,5.8,13,13,0,0,1,2.87-.45,7.76,7.76,0,0,1,2.17.28,6.73,6.73,0,0,1,2,.91.29.29,0,0,1,.17.07c.93.63,1.85,1.2,2.77,1.72q10.4,5.75,19.38-.64a3.4,3.4,0,0,0,.75-1,6,6,0,0,0,.68-1.23,5.89,5.89,0,0,0,.44-1.13,10.06,10.06,0,0,0,.37-1.72,10.29,10.29,0,0,0,.28-1.56v-.75a17.58,17.58,0,0,0-.17-3.12v0c-.12-.58-.24-1.18-.35-1.78a10.23,10.23,0,0,0-3.28-5.23,4.18,4.18,0,0,0-2.37-.87,13.42,13.42,0,0,0-4.81.37,18.52,18.52,0,0,0-2,.56c-.86.25-1.79.58-2.77,1-.72.32-1.45.6-2.19.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M208.49,401.34l9.9-3q1.38-.48.05-4.24-6.62-24-12.7-30.08l-20.29-18.26a28.51,28.51,0,0,0-3.28-3c-1.39-1.2-3.58-1.86-6.57-2v.15l2.87.18a20.88,20.88,0,0,1,.65,2.43q2.37,10.83,5.17,21.52L197,374.16q7.59,13.84,8.45,20.45T208.49,401.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M154.91,333.73l2.8-1.23c.74-.26,1.47-.54,2.19-.86,1-.38,1.91-.71,2.77-1a1.64,1.64,0,0,1,0-.41c-.05-1.19-.06-2.15,0-2.89-1.67-.18-2.56-2.08-2.68-5.67l.13,0a4.26,4.26,0,0,0,2.8-1.44,5.4,5.4,0,0,0,.1-6.37,2.88,2.88,0,0,0-2.68-1.21,2.78,2.78,0,0,0-1.94,1,5.75,5.75,0,0,0-1.51,3.8v.33Q156.38,328.84,154.91,333.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M187.23,398.3c-2-.65-4.58-.44-7.72.64q-10.81,3.24-28.1,5.23a40.11,40.11,0,0,0,.66,6.21,1.73,1.73,0,0,0,1.58,1.71.54.54,0,0,1,.26.09,3.73,3.73,0,0,0,1.16,0q8.46-1.24,16.64-3.29,11.37-2.58,15.26-2.77a1.49,1.49,0,0,0,.7-.18,3.47,3.47,0,0,1,.48-.17c.79-.45,1-1.19.56-2.23A27.4,27.4,0,0,1,187.23,398.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M140.3,508.84a1.27,1.27,0,0,0,1,.16l6.38-1.32,2.59-.59c1.18-.34,1.57-1,1.16-2-.12-.49-.26-1-.42-1.49-.41-1.33-.81-2.64-1.21-3.92-.23-.73-.46-1.46-.68-2.21v-.25c-.45-1.39-.85-2.8-1.21-4.24a137.5,137.5,0,0,1-3.75-22.61,16.13,16.13,0,0,1,4.8-13.28l15-13.93a90.16,90.16,0,0,1,19.36-13.86q6.6-3.63,6.15-10.86a81.39,81.39,0,0,0-1.79-12.5,1.49,1.49,0,0,1-.7.18q-3.89.19-15.26,2.77-8.18,2-16.64,3.29a3.73,3.73,0,0,1-1.16,0,.54.54,0,0,0-.26-.09v.74q-15.09,21.59-23,39.09c-1.06,2.32-2,4.58-2.87,6.76a16.05,16.05,0,0,0-.16,9.27,2.59,2.59,0,0,0,.16.52q.54,2.58,1.2,5.1,2.63,10,5.59,19.41c.44,1.44.9,2.85,1.39,4.24a.4.4,0,0,0,.09.25c.24.75.48,1.48.71,2.21.49,1.28,1,2.59,1.39,3.92q.78,2.25,1.64,4.38v0A1,1,0,0,0,140.3,508.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M218.39,398.36l-9.9,3,.54,2.55a1.7,1.7,0,0,0,.84,1.27,2.11,2.11,0,0,0,.81-.07l7.5-2.42a.7.7,0,0,0,.33-.23,1.43,1.43,0,0,0,.4-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M212.36,415.49l-.74-2.24a2,2,0,0,1,0-1.37,2.11,2.11,0,0,1,1.12-.82l6.77-2.19a1.52,1.52,0,0,1,2.15,1l-1.12-3.4a8.71,8.71,0,0,0-2-4,.7.7,0,0,1-.33.23l-7.5,2.42a2.11,2.11,0,0,1-.81.07c-.68.72-.81,2.06-.4,4l.73,4C210.57,414.62,211.28,415.41,212.36,415.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M221.66,409.85a1.52,1.52,0,0,0-2.15-1l-6.77,2.19a2.11,2.11,0,0,0-1.12.82,2,2,0,0,0,0,1.37l.74,2.24.17.48a1.53,1.53,0,0,0,2.19,1.08l6.77-2.19a1.54,1.54,0,0,0,1.08-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M205.74,509.75c.33.81,1,1,2.08.7q3.63-.87,6.9-1.91c.93-.34,1.82-.65,2.68-.93a.74.74,0,0,0,.55-.86,1.33,1.33,0,0,0-.25-.73l-1-1.68c-1-1.53-1.84-3.09-2.65-4.66-.36-.73-.74-1.46-1.15-2.21a.45.45,0,0,1-.07-.25c-.79-1.39-1.52-2.8-2.21-4.24a242.22,242.22,0,0,1-10.37-25q-2.88-7.81-5.24-16a151.4,151.4,0,0,1-5.4-32,13.76,13.76,0,0,0-.12-1.48q.45,7.23-6.15,10.86A90.16,90.16,0,0,0,164,443.16l22.11,32.78a2.83,2.83,0,0,1,.4.63c.42.69.85,1.38,1.28,2.06q4.19,6.47,8.38,14.35,1.15,2.16,2.31,4.24a1.92,1.92,0,0,0,.12.25c.43.75.86,1.48,1.26,2.21Q202.71,504.75,205.74,509.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M148.48,511.94a6,6,0,0,0-3.64,2q-1.4,1.34-3-1.35l-1.5-3.75a52.64,52.64,0,0,1-9.32,4.89c-1.31.53-2.63,1-4,1.45a3.32,3.32,0,0,0-1.86,1.82,4.77,4.77,0,0,0-.4,1.09c.79.47,2.32.7,4.59.7h18.06c2,0,3.1-.19,3.4-.68a7.07,7.07,0,0,0-.05-.72c-.11-.53-.2-1-.28-1.47C150,513.73,149.34,512.41,148.48,511.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M150.81,518.11c-.3.49-1.44.72-3.4.68H129.35c-2.27,0-3.8-.23-4.59-.7v0q-.29,1.71,2.43,1.89h21.25Q150.87,520,150.81,518.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M140.3,508.84l1.5,3.75q1.65,2.68,3,1.35a6,6,0,0,1,3.64-2l-.77-4.26L141.33,509A1.27,1.27,0,0,1,140.3,508.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M207.82,510.45c-1,.34-1.75.11-2.08-.7a55,55,0,0,1-7.89,4c-1.33.53-2.64,1-3.94,1.45a4.87,4.87,0,0,0-1.21.74,4.6,4.6,0,0,0-1,2.19c.81.49,2.34.72,4.59.68h18.07c2,0,3-.19,3.24-.68,0-.2,0-.44,0-.72a1.84,1.84,0,0,1-.11-.56q-.75-4.1-2.13-4.89a5.68,5.68,0,0,0-3.63,2q-1.38,1.34-3-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M217.6,518.11c-.2.49-1.28.72-3.24.68H196.29c-2.25,0-3.78-.19-4.59-.68-.25,1.14.55,1.77,2.42,1.89h21.22C217,520,217.75,519.36,217.6,518.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M214.72,508.54q-3.27,1-6.9,1.91l.86,2.14q1.65,2.68,3,1.35a5.68,5.68,0,0,1,3.63-2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.7317ad1ff8e91798f89811b61f038172.svg";
export { ForwardRef as ReactComponent };